import React from "react";

export const About = () => {
  return (
    <div>
      This is an about component
      <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cum corporis
        odio, nesciunt sed eveniet, nemo amet, dignissimos magnam itaque ipsam
        possimus. Inventore vitae, perferendis harum quas cupiditate adipisci
        repellendus tempore asperiores at consequatur quos?
      </p>
    </div>
  );
};
